import React, { useState } from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import Faq3 from '../components/faqs/Faq3';
import dataFaqs from '../assets/fake-data/data-faq';
import Footer from '../components/footer/Footer';

import img from '../assets/images/layouts/touch.png';

function Contact(props) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    instagram: '',
    subject: 'vip-table',
    message: ''
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (sent) setSent(false);
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (!form.name || !form.email || !form.message) {
      alert('Please fill out your name, email, and message.');
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      alert('Please enter a valid email address.');
      return;
    }

    const webhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
    if (!webhookUrl) {
      alert(
        'Missing REACT_APP_DISCORD_WEBHOOK_URL in your environment. Add it to your .env file and restart the dev server.'
      );
      return;
    }

    const subjects = {
      'vip-table': 'VIP Table Reservation',
      'guest-list': 'Guest List Request',
      'event-collab': 'Event Collaboration',
      'media-press': 'Media / Press Inquiry',
      other: 'Other'
    };
    const subjectText = subjects[form.subject] || 'Contact';

    // Nicely formatted Discord message
    const content = [
      '**📩 New NXTLVL Contact Form Submission**',
      `**Subject:** ${subjectText}`,
      `**Name:** ${form.name}`,
      `**Email:** ${form.email}`,
      form.phone ? `**Phone:** ${form.phone}` : null,
      form.instagram ? `**Instagram:** ${form.instagram}` : null,
      '',
      '**Message:**',
      form.message
    ]
      .filter(Boolean)
      .join('\n');

    try {
      setSending(true);
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content })
      });

      // Discord returns 204 No Content on success
      if (res.ok) {
        setSent(true);
        setForm({
          name: '',
          email: '',
          phone: '',
          instagram: '',
          subject: 'vip-table',
          message: ''
        });
      } else {
        const txt = await res.text();
        throw new Error(txt || `Request failed with status ${res.status}`);
      }
    } catch (err) {
      console.error(err);
      setError('Failed to send. Please try again in a moment.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="wrapper">
      <PageTitle title="Contact" />

      <section className="touch">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Get in Touch!</span>
                </h6>
                <h3 className="heading">
                  Let’s Start Working <br />
                  Together
                </h3>
              </div>
              <div className="touch__main">
                <div className="info">
                  <h5>Contact information</h5>
                  <ul className="list">
                    <li>
                      <p>Orlando, Florida</p>
                    </li>
                    <li>
                      <p>+1 689-267-9495</p>
                    </li>
                    <li>
                      <p>vip@nxtlvlnights.com</p>
                    </li>
                  </ul>

                  <div className="image">
                    <img src={img} alt="cyfonii" />
                  </div>
                </div>

                <form className="form-box" onSubmit={handleSubmit} noValidate>
                  <div className="row">
                    <div className="col">
                      <label htmlFor="name">Your name</label>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="John Doe"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="email">Your email</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="form-control"
                        placeholder="you@example.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <label htmlFor="phone">Your phone</label>
                      <input
                        id="phone"
                        name="phone"
                        type="tel"
                        inputMode="tel"
                        className="form-control"
                        placeholder="689-267-9495"
                        value={form.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="instagram">Instagram</label>
                      <input
                        id="instagram"
                        name="instagram"
                        type="text"
                        className="form-control"
                        placeholder="@yourhandle"
                        value={form.instagram}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <label htmlFor="subject">Subject</label>
                      <select
                        id="subject"
                        name="subject"
                        className="form-control"
                        value={form.subject}
                        onChange={handleChange}
                      >
                        <option value="vip-table">VIP Table Reservation</option>
                        <option value="guest-list">Guest List Request</option>
                        <option value="event-collab">Event Collaboration</option>
                        <option value="media-press">Media / Press Inquiry</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <label htmlFor="mess">Message</label>
                      <textarea
                        id="mess"
                        name="message"
                        className="form-control"
                        cols="30"
                        rows="10"
                        placeholder="Tell us the date, group size, and what you need..."
                        value={form.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row mb-0">
                    <div className="col">
                      <button type="submit" className="action-btn" disabled={sending}>
                        <span>{sending ? 'Sending…' : sent ? 'Sent to Discord' : 'Send Now'}</span>
                      </button>
                      {error && (
                        <p style={{ marginTop: 12, color: '#ff7a7a' }}>{error}</p>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Faq3 data={dataFaqs} />
      <Footer />
    </div>
  );
}

export default Contact;